const DRAWER_ID = 'krasis-pdp-info-drawer';
const TRIGGER_SELECTOR = '[data-krasis-pdp-info-trigger]';
const CURRENT_TITLE_ID = 'krasis-pdp-info-drawer-current-title';

if (!window.KrasisPdpInfoDrawerReady) {
  window.KrasisPdpInfoDrawerReady = true;

  document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const trigger = target?.closest(TRIGGER_SELECTOR);

    if (!(trigger instanceof HTMLElement)) return;

    event.preventDefault();

    const templateId = trigger.dataset.krasisPdpInfoTemplate;
    const template = templateId ? document.getElementById(templateId) : null;
    const drawer = document.getElementById(DRAWER_ID);
    const body = drawer?.querySelector('[data-krasis-pdp-info-body]');
    const dialog = drawer?.querySelector('dialog');

    if (
      !(template instanceof HTMLTemplateElement) ||
      !(body instanceof HTMLElement) ||
      !(dialog instanceof HTMLDialogElement)
    ) {
      console.warn('Krasis PDP information drawer content was not found.');
      return;
    }

    body.replaceChildren(template.content.cloneNode(true));
    body.scrollTop = 0;

    const panelTitle = body.querySelector('[data-krasis-pdp-info-title]');

    if (panelTitle instanceof HTMLElement) {
      panelTitle.id = CURRENT_TITLE_ID;
      dialog.setAttribute('aria-labelledby', CURRENT_TITLE_ID);
    } else {
      dialog.setAttribute('aria-labelledby', 'krasis-pdp-info-drawer-product-heading');
    }

    await customElements.whenDefined('theme-drawer');
    drawer.open();
    dialog.focus({ preventScroll: true });
  });
}
